const PictureSvg: React.FC<React.SVGProps<SVGSVGElement>> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="165" height="128.333" viewBox="0 0 165 128.333" {...props}>
            <path id="Icon_awesome-images" data-name="Icon awesome-images" d="M137.5,112.25v4.583a13.75,13.75,0,0,1-13.75,13.75h-110A13.75,13.75,0,0,1,0,116.833V43.5A13.75,13.75,0,0,1,13.75,29.75h4.583V89.333A22.943,22.943,0,0,0,41.25,112.25ZM165,89.333V16A13.75,13.75,0,0,0,151.25,2.25h-110A13.75,13.75,0,0,0,27.5,16V89.333a13.75,13.75,0,0,0,13.75,13.75h110A13.75,13.75,0,0,0,165,89.333ZM73.333,29.75A13.75,13.75,0,1,1,59.583,16,13.75,13.75,0,0,1,73.333,29.75ZM45.833,71l15.9-15.9a3.438,3.438,0,0,1,4.861,0L77.917,66.417,116.736,27.6a3.438,3.438,0,0,1,4.861,0l25.069,25.069V84.75H45.833Z" transform="translate(0 -2.25)" fill="#666" opacity="0.38" />
        </svg>
    );
}

export default PictureSvg;

